// removed by extract-text-webpack-plugin
module.exports = {"avatar":"ahzms","profileName":"xxETZ","search":"_1qGRX"};


//////////////////
// WEBPACK FOOTER
// ./app/components/comment-avatar/comment-avatar.scss
// module id = 1113
// module chunks = 0 3 5